<template>
  <div class="zrbhdMsgPage">
    <van-cell-group class="forestInput">
      <van-field
        v-model="baseData.name"
        readonly
        :label="$t('common.name') + '：'"
      />
      <van-field
        v-model="baseData.type"
        readonly
        :label="$t('common.name') + '：'"
      />
      <van-field
        v-model="baseData.yztNd"
        readonly
        :label="$t('common.yearTit') + '：'"
      />
      <van-field
        v-model="baseData.xianName"
        readonly
        :label="$t('common.politicalTit') + '：'"
      />
      <van-field
        v-model="baseData.remarks"
        rows="3"
        autosize
        type="textarea"
        readonly
        :label="$t('common.explainTit') + '：'"
      />
    </van-cell-group>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "zrbhdMsg",
  data() {
    return {
      zrbhdId: "", //自然保护地Id
      baseData: {},
      refreshPage: false,
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "自然保护地信息";
    this.clientType = getDeviceType();

    this.$nextTick(function () {
      this.zrbhdId = this.$route.query.commonId;
      if (this.zrbhdId == undefined) {
        this.zrbhdId = this.param.id;
      }
      this.initPage();
    });
    // this.zrbhdId = "9";
    // this.initPage();
  },
  components: {
    refreshPage,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .geoBaohudi({
          objid: _this.zrbhdId,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.zrbhdId = _this.param.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.zrbhdPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  .fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }
  .forestInput {
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>